import {
  BreadcrumbServiceV1,
  BreadcrumbV1,
} from '@volkswagen-onehub/breadcrumb-service';
import React from 'react';
import {BreadcrumbBar} from './breadcrumb-bar';

interface AppProps {
  readonly breadcrumbService: BreadcrumbServiceV1;
  readonly breadcrumbConsumerIds: string[];
}

export function App({
  breadcrumbService,
  breadcrumbConsumerIds,
}: AppProps): JSX.Element | null {
  const createBreadcrumbs = () =>
    new Array<BreadcrumbV1>().concat(
      ...breadcrumbConsumerIds.map((consumerId) =>
        breadcrumbService.getBreadcrumbs(consumerId),
      ),
    );

  const [breadcrumbs, setBreadcrumbs] = React.useState(createBreadcrumbs);

  React.useEffect(
    () =>
      breadcrumbService.listen((consumerId) => {
        if (breadcrumbConsumerIds.includes(consumerId)) {
          setBreadcrumbs(createBreadcrumbs());
        }
      }),

    [breadcrumbConsumerIds],
  );

  if (!breadcrumbs.length) {
    return null;
  }

  return <BreadcrumbBar breadcrumbs={breadcrumbs} />;
}
